import Vue from "vue";
import App from "./App.vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import router from "./router";
import '../src/assets/css/styles.css';
import store from './store/index'


Vue.use(Vuetify);

const vuetify = new Vuetify();

Vue.config.productionTip = false;

new Vue({
  vuetify, // Asegúrate de incluir esta línea
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
